window.dataLayer = window.dataLayer || [];

function swymCallbackFn(swat) {
  // Swym event listeners
  // Product added to wishlist/favourites
  swat.evtLayer.addEventListener(
    swat.JSEvents.addedToWishlist,
    function (event) {
      console.log(event);

      sendAlgoliaEvent(event);
      sendGAEvent(event);
      sendDYEvent(event);

      setTimeout(function () {
        refreshFavouritesDropdown();
        document.dispatchEvent(new CustomEvent('swym:variant-changed'));
      }, 1000);
    }
  );

  // Product removed to wishlist/favourites
  swat.evtLayer.addEventListener(
    swat.JSEvents.removedFromWishlist,
    function (event) {
      sendAlgoliaEvent(event);
      sendGAEvent(event);
      sendDYEvent(event);

      console.log('swym:removedFromWishlist');
      console.log(event);

      setTimeout(function () {
        refreshFavouritesDropdown();
        document.dispatchEvent(new CustomEvent('swym:variant-changed'));
      }, 1000);
    }
  );

  // Initialize wishlist button when content is dynamically loaded on search/PLP
  document.addEventListener('swym:collections-loaded', function () {
    console.log('swym:collections-loaded');
    swat.initializeActionButtons('.listing-grid');
  });

  // Initialize wishlist button when there is a change in variant
  document.addEventListener('swym:variant-changed', function (event) {
    swat.initializeActionButtons('.wishlist__button');
  });

  refreshFavouritesDropdown();
}

function sendGAEvent(event) {
  const productTitle = event.detail.d.dt;
  const eventAction = event.type === 'sw:addedtowishlist' ? 'ADDED' : 'REMOVED';
  const page = window.location.pathname.startsWith('/products/')
    ? 'PDP'
    : 'PLP';

  window.dataLayer.push({
    event: `${page}-${eventAction}-WISHLIST`,
    action: `${page}-${eventAction}-WISHLIST`,
    category: 'wishlist',
    label: productTitle,
  });
}

function sendDYEvent(event) {
  const product = event.detail.d;
  const eventAction = event.type === 'sw:addedtowishlist' ? 'ADDED' : 'REMOVED';
  const page = window.location.pathname.startsWith('/products/')
    ? 'PDP'
    : 'PLP';

  const size = product.vi.split(' / ');

  if(typeof DY.API != "undefined") {
    DY.API('event', {
      name: `${page}-${eventAction}-WISHLIST`,
      properties: {
        product: {
          title: product.dt,
          price: product.pr,
          sku: product.sku,
          productId: product.empi,
          variant: product.epi,
          size: size[size.length - 1],
        },
      },
    });
  }
}

function sendAlgoliaEvent(event) {
  // The insights snippet (app_algolia.liquid) only renders when
  // settings.enable_algolia is on, and is blocked for bots and by ad-blockers.
  if (typeof aa !== 'function' || !window.algoliaShopify?.config) return;

  const action =
    event.type === 'sw:addedtowishlist' ? 'Added to' : 'Removed from';
  const productId = String(event.detail.d.empi);
  const variantId = String(event.detail.d.epi);

  // PDP
  if (window.location.pathname.startsWith('/products/')) {
    // Check if the user reached this product from Algolia (via Search or PLP basically)
    const productData =
      JSON.parse(localStorage.getItem('algoliaProducts')) || [];
    const product = productData.find((p) => p.productId === productId);

    if (product) {
      aa('convertedObjectIDsAfterSearch', {
        userToken: getAlgoliaUserToken(),
        eventName: `PDP: ${action} Wishlist`,
        index: `${algoliaShopify.config.index_prefix}products`,
        objectIDs: [variantId],
        queryID: product.queryId,
      });
    } else {
      aa('convertedObjectIDs', {
        userToken: getAlgoliaUserToken(),
        eventName: `PDP: ${action} Wishlist`,
        index: `${algoliaShopify.config.index_prefix}products`,
        objectIDs: [variantId],
      });
    }
  } else {
    const listing = document.querySelector('listing-algolia');

    if (listing && listing.queryId) {
      aa('convertedObjectIDsAfterSearch', {
        userToken: getAlgoliaUserToken(),
        eventName: `PLP: ${action} Wishlist`,
        index: listing.buildIndexParams(),
        objectIDs: [variantId],
        queryID: listing.queryId,
      });
    } else {
      aa('convertedObjectIDs', {
        userToken: getAlgoliaUserToken(),
        eventName: `PLP: ${action} Wishlist`,
        index: `${algoliaShopify.config.index_prefix}products`,
        objectIDs: [variantId],
      });
    }
  }
}

function refreshFavouritesDropdown() {
  window._swat.fetch(function (products) {
    refreshFavouritesCount(products);
  });
}

function refreshFavouritesCount(products) {
  document
    .querySelectorAll('[data-header-favourites-count]')
    .forEach((node, index) => {
      node.innerHTML = `${products.length}`;

      if (products.length == 0) {
        node.classList.add('hidden');
      } else {
        node.classList.remove('hidden');
      }
    });
}

function sortByVariantTitle(a, b) {
  const sortScript = document.getElementById('fav_S_order');
  if (!sortScript) return 0;

  const cleanSortOrder = sortScript.innerText
    .replace(/\\n/g, '')
    .replace(/[\n\r;\[\]]/g, '')
    .replace(/\\\"/g, '"')
    .replace(/\"/g, '')
    .split(',')
    .map((item) => item.trim());

  if (cleanSortOrder.length === 0) return 0;

  return (
    cleanSortOrder.indexOf(a.option2.toLowerCase().trim()) -
    cleanSortOrder.indexOf(b.option2.toLowerCase().trim())
  );
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);
